import { useTranslation } from "react-i18next";
import { DeviceWithoutLegacyPassword } from "../../../../generated/types";
import { LegacyPacksSection, useLegacyPacks } from "../../device/LegacyPacks";

/** Packs d'un produit legacy sur la fiche élevage, en lecture seule (modifiés sur la machine). */
export const DeviceLegacyPacks = ({
  device,
}: {
  device: DeviceWithoutLegacyPassword;
}) => {
  const { t } = useTranslation();
  const state = useLegacyPacks(device.uuid, true);

  return (
    <div className="flex items-start gap-2 pl-2">
      <span className="text-xs text-grey-medium shrink-0 py-0.5">
        {t("device-licenses")}
      </span>
      <LegacyPacksSection state={state} />
    </div>
  );
};
